/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  NotificationsDispatchPublicControllerResolveBonusLinkQueryResponse,
  NotificationsDispatchPublicControllerResolveBonusLinkPathParams,
  NotificationsDispatchPublicControllerResolveBonusLink404,
} from '../../types/NotificationsDispatchPublicControllerResolveBonusLink.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { notificationsDispatchPublicResolveBonusLink } from '../../methods/notificationsDispatchPublicResolveBonusLink.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const notificationsDispatchPublicResolveBonusLinkQueryKey = (
  code: NotificationsDispatchPublicControllerResolveBonusLinkPathParams['code'],
) => [{ url: '/api/telegram/notifications/bonus-links/:code', params: { code: code } }] as const;

export type NotificationsDispatchPublicResolveBonusLinkQueryKey = ReturnType<
  typeof notificationsDispatchPublicResolveBonusLinkQueryKey
>;

export function notificationsDispatchPublicResolveBonusLinkQueryOptions(
  code: NotificationsDispatchPublicControllerResolveBonusLinkPathParams['code'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = notificationsDispatchPublicResolveBonusLinkQueryKey(code);
  return queryOptions<
    NotificationsDispatchPublicControllerResolveBonusLinkQueryResponse,
    ResponseErrorConfig<NotificationsDispatchPublicControllerResolveBonusLink404>,
    NotificationsDispatchPublicControllerResolveBonusLinkQueryResponse,
    typeof queryKey
  >({
    enabled: !!code,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return notificationsDispatchPublicResolveBonusLink(code, config);
    },
  });
}

/**
 * {@link /api/telegram/notifications/bonus-links/:code}
 */
export function useNotificationsDispatchPublicResolveBonusLink<
  TData = NotificationsDispatchPublicControllerResolveBonusLinkQueryResponse,
  TQueryData = NotificationsDispatchPublicControllerResolveBonusLinkQueryResponse,
  TQueryKey extends QueryKey = NotificationsDispatchPublicResolveBonusLinkQueryKey,
>(
  code: NotificationsDispatchPublicControllerResolveBonusLinkPathParams['code'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        NotificationsDispatchPublicControllerResolveBonusLinkQueryResponse,
        ResponseErrorConfig<NotificationsDispatchPublicControllerResolveBonusLink404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? notificationsDispatchPublicResolveBonusLinkQueryKey(code);

  const query = useQuery(
    {
      ...notificationsDispatchPublicResolveBonusLinkQueryOptions(code, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<NotificationsDispatchPublicControllerResolveBonusLink404>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
